var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmarkCircle2Outline = function SvgCheckmarkCircle2Outline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2FBD14",
    d: "M10 1.667A8.333 8.333 0 0 0 1.667 10 8.333 8.333 0 0 0 10 18.333a8.333 8.333 0 1 0 0-16.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.25 6.992 9.1 11.158 7.742 9.4a.834.834 0 1 0-1.317 1.025l2.025 2.592a.835.835 0 0 0 1.317-.009l3.808-5a.84.84 0 0 0-1.333-1.016h.008z"
  }))));
};

export default SvgCheckmarkCircle2Outline;